export default {
  primary: {
    padding: '1rem 2.5rem',
    color: 'white',

    transition: 'all ease-in-out 0.7s',
    backgroundSize: '204% 100%',
    backgroundColor: 'tertiary',
    backgroundImage: 'linear-gradient(to right,rgba(0,0,0,0) 50%,#f5951e 50%)',
    border: 'none',
    borderRadius: '100px',
    fontFamily: 'heading',
    fontWeight: 'normal',
    ':hover': {
      backgroundColor: 'transparent',
      backgroundPosition: '-98% 0%',
      color: 'light'
    }
  },
  secondary: {
    color: 'light',
    borderRadius: '0px',
    textTransform: 'uppercase',
    fontFamily: 'heading',
    display: 'flex',
    border: 'none',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '0.5rem 1rem',
    backgroundColor: 'primary',
    transition: 'all ease-in-out 0.5s',
    ':hover': {
      backgroundColor: 'secondary',
      borderColor: 'white'
    }
  }
}
